import { DATA_KEY } from "./internal/constants";
import { lensPath } from "../fp";

const dataLens = lensPath([DATA_KEY]);

export default dataLens;
